import SectionHeading from '@commons/headings/section'
import Tabs from '@commons/tabs'
import Column from '@components/column'
import Symptoms from './symptoms'
import Departments from './departments'
import LabTests from './labTests'
import Medicines from './medicines'
import Healthcare from './healthcares'
const AdminCategoryManagementPage = () => {
  const items = [
    {
      title: 'Symptoms & Problems',
      key: 'symptoms',
      Component: Symptoms,
    },
    {
      title: 'Department Category',
      key: 'department',
      Component: Departments,
    },
    {
      title: 'Lab Test Category',
      key: 'labTest',
      Component: LabTests,
    },
    {
      title: 'Medicine Category',
      key: 'medicine',
      Component: Medicines,
    },
    {
      title: 'Healthcare Category',
      key: 'healthcare',
      Component: Healthcare,
    },
  ]

  return (
    <>
      <Column styleColumn="margin-bottom:20px;">
        <SectionHeading title="Category Management" />
      </Column>
      <Tabs items={items} restore={true} />
    </>
  )
}

export default AdminCategoryManagementPage
